import { render, staticRenderFns } from "./Reply.vue?vue&type=template&id=1591b1fa&scoped=true"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"
import style0 from "./Reply.vue?vue&type=style&index=0&id=1591b1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_fjgmzwr3s5tq3rnxsqdvyzw3tu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591b1fa",
  null
  
)

export default component.exports